import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import Footer from '../../shared/Footer/footer.vue';
import { BlogListDelegate } from '../../services/DataDelegate/BlogDelegate/blog.list.delegate';
import AboutMe from '../../shared/AboutMe/about.me.vue';
import BlogList from '../../shared/BlogList/blog.list.vue';
import Banner from '../../shared/Banner/banner.vue';
import { CommonConfig } from '../../configs/config.common';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import { WechatDelegate } from '../../services/DataDelegate/WechatDelegate/wechat.delegate';
import { Models } from '../../models/models';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import ContactAgent from '../../shared/ContactAgent/contact.agent.vue';
import * as T_T from 'cryface';
import { HimuraInject } from 'himura';
import SocialShareComponent from '../../shared/SocialShare/social.share.vue';
import AgentFrontstoreStandardLayout from '../../layout/AgentFrontstoreStandardLayout/agent.frontstore.standard.layout.vue';
import dd from 'dingtalk-jsapi';

@Component({
   components: {
      Header,
      Footer,
      Banner,
      AboutMe,
      BlogList,
      SpinLoader,
      ContactAgent,
      SocialShareComponent,
      'layout': AgentFrontstoreStandardLayout,
   }
})
export default class BlogListPage extends Vue {
   public title: string = 'BlogListPage';

   public blogListDelegate = new BlogListDelegate();

   public currentPage = 1;

   public totalRows = 0;

   public perPage = 6;

   public configs = new CommonConfig();

   public userInfoService = new UserInfoDelegate();

   public wechat = new WechatDelegate();

   public isLoading = false;

   public async init() {
   }

   public async pageData(pageNo: number) {
   }

   public setPage(totalPage: number, totalRecord: number, pageSize: number) {
      this.totalRows = totalRecord;
      this.perPage = pageSize;
   }

   public toDetail(blogid: number) {
      this.$router.push({ path: `/blog/${blogid}` });
   }

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public async onUserChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val.value)) {
         this.isLoading = true;
         await this.configWX(val);
         await this.configSocial(val);
         await T_T.delay(500);
         await this.configDingTalk(val);
         this.isLoading = false;
      }
   }

   public async created() {
      window.scrollTo(0, 0);
   }

   public async configSocial(val: any) {
      const link = location.href.split('#')[0];
      const config = {
         url: link, // 网址，默认使用 window.location.href
         source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
         title: `向您分享我的博客`, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
         description: `Blogs Sharing Coming From Agent ${val.value.agentName}, RIFO, 让天下人人有房有家。`, // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
         image: T_T.simpleDetect(val.value.agentImageUrl) ? val.value.agentImageUrl : '', // 图片, 默认取网页中第一个img标签
         wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
         wechatQrcodeHelper: '<p>微信里点“发现”，扫一下</p><p>二维码便可分享至朋友圈。</p>'
      };
      this.$store.commit('setSocialShare', config);
   }

   public async configDingTalk(val: any) {
      if (window.navigator.userAgent.toLowerCase().indexOf('dingtalk') === -1) {
         return;
      }
      dd.biz.navigation.setRight({
         show: true,
         control: true,
         text: '',
         onSuccess: function () {
            dd.biz.util.share({
               type: 0,
               url: location.href.split('#')[0],
               title: `向您分享我的博客`,
               content: `来自经纪 ${val.value.agentName} 的博客分享, RIFO, 让天下人人有房有家。`,
               image: 'https://files.realjaja.com/rifo_wechat_logo.png'
            });
         }
      });
   }
   public async configWX(val: any) {
      if (this.wechat.isWeChat()) {
         const entry = HimuraInject.Injector.getInstance().getResourceByKey('entryUrl')!.value;
         const link = this.wechat.isWechatIos() ? entry.split('#')[0] : location.href.split('#')[0];
         const shareConfig: Models.IWechatShareConfig = {
            title: `向您分享我的博客`,
            desc: `来自经纪 ${val.value.agentName} 的博客分享, RIFO, 让天下人人有房有家。`,
            imgUrl: T_T.simpleDetect(val.value.agentImageUrl) ? val.value.agentImageUrl : '',
            link: location.href.split('#')[0],
         };
         const wx = require('weixin-js-sdk');
         const options = await this.wechat.getConfig(link);
         wx.config(options);
         try {
            await this.wechat.ReadyPromise(wx);
            this.wechat.share(wx, shareConfig);
         } catch (e) {
            alert(e.errMsg);
            alert(location.href);
         }
      }
   }
}
